import { useEffect } from 'react';
import Navbar from './Components/Navbar/Navbar';
import HomeCarousel from "./Pages/Home/HomeCarousel";
import Footer from "./Components/Footer/Footer";
import HomeObjectTive from './Pages/Home/HomeObjectTive';
import HomeService from './Pages/Home/HomeService';
import NurseTeam from './Pages/Home/NurseTeam';

function App() {

  useEffect(() => {
    // SEO Optimization
    document.title = 'ราชพฤกษ์ไตเทียม | ศูนย์ฟอกเลือดด้วยเครื่องไตเทียม มาตรฐาน HA ทั่วประเทศไทย';
    
    // Meta Description for SEO
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'ศูนย์ฟอกเลือดด้วยเครื่องไตเทียมชั้นนำของประเทศไทย มีสาขากว่า 70+ แห่งทั่วประเทศ ดูแลผู้ป่วยด้วยมาตรฐาน HA และทีมแพทย์พยาบาลผู้เชี่ยวชาญ บริการ HD และ HDF');
    }

    // Meta Keywords for SEO
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'ไตเทียม, ฟอกเลือด, ราชพฤกษ์, hemodialysis, ศูนย์ไตเทียม, โรคไต, HD, HDF, ไตวาย, รักษาไต, คลินิกไตเทียม');
    }
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="w-full">
        <HomeCarousel />
        <HomeObjectTive />
        <NurseTeam />
        <HomeService />
      </main>
      <Footer />
    </div>
  );
}

export default App;
